export enum TypesSettingsApplication {
  SET_SETTINGS_APPLICATION_AMOUNT = 'user.SET_SETTINGS_APPLICATION_AMOUNT',
  SET_SETTINGS_APPLICATION_TERM = 'user.SET_SETTINGS_APPLICATION_TERM',
  SET_SETTINGS_APPLICATION_PROMOCODE = 'user.SET_SETTINGS_APPLICATION_PROMOCODE',
  SET_SETTINGS_APPLICATION_LOAN_PURPOSE = 'user.SET_SETTINGS_APPLICATION_LOAN_PURPOSE',
}
